import GoalEntryDialog from './GoalEntryDialog'; export default GoalEntryDialog;
